import React, { useState } from 'react';
import classes from './style.module.scss';
import Arrow from '../../media/arrow.svg';

const ScrollButton = () => {
    const getScroll = () => {
        window.scrollTo(0, 0);
    };

    const [showScroller, setShowScroller] = useState(false);

    window.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
            setShowScroller(true);
        } else {
            setShowScroller(false);
        }
    });

    return (
        <button
            onClick={getScroll}
            className={
                showScroller
                    ? classes.scrollButton
                    : classes.scrollButtonInvisible
            }
        >
            <div>
                <img src={Arrow} alt="arrow" />
                <span></span>
            </div>
        </button>
    );
};

export default ScrollButton;
